interface EyebrowProps {
  text: string;
  tone?: "muted" | "cobalt";
}

const toneClass = {
  muted: "text-ink-3",
  cobalt: "text-cobalt-dark",
} as const;

export function Eyebrow({ text, tone = "muted" }: EyebrowProps) {
  return (
    <span className={`font-mono text-xs uppercase tracking-wide ${toneClass[tone]}`}>
      {text}
    </span>
  );
}
